import React from "react";

export const LandingFormIntroHeader = () => {
  return (
    <div className="h-[var(--header-height)]">
      <div className="h-full w-full flex-col flex form-container gap-3 items-center justify-center">
        <img
          src={"/assets/heart_logo.png"}
          alt="heart logo icon"
          className="size-12"
        />

        <h1 className="text-2xl font-bold text-center">
          Create your AI Girlfriend
          <br />
          with <span className="text-primary">NectarAI</span>
        </h1>
      </div>
    </div>
  );
};
